import { render } from "./TermsCondition.vue?vue&type=template&id=4fdbf206"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"

import "./TermsCondition.vue?vue&type=style&index=0&id=4fdbf206&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__